import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { PermissionService } from '../../services/permission.service';

@Injectable({
  providedIn: 'root'
})
export class AppPermissionsGuard  {
  constructor(
    private permissionService: PermissionService,
    private router: Router
  ) {}

  canActivate(next: ActivatedRouteSnapshot): Observable<boolean> {
    return new Observable<boolean>(observer => {
      if (!this.permissionService.hasAppPermission(next.data.permission)) {
        this.router.navigate(['./']);
        return observer.next(false);
      }
      return observer.next(true);
    });
  }
}
